import React, { useEffect, useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import Form from '../common/Form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

export default function InvitationsForm({ onSubmit, handleCancel, building }) {
  const classes = useStyles()
  const history = useHistory()
  const [values, setValues] = useState({})
  const [apartment, setApartment] = useState(null)
  const [selectedBuilding, setSelectedBuilding] = useState(building)
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const [{ getApartmentsFromBuildingState }, { getApartmentsFromBuilding }] =
    useApartmentsApi()

  useEffect(() => {
    const fetchData = async () => {
      getBuildings()
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (selectedBuilding) {
      const fetchApartmentsFromBuilding = async () => {
        getApartmentsFromBuilding(selectedBuilding.id)
      }
      fetchApartmentsFromBuilding()
    }

    setApartment(null)
  }, [selectedBuilding && selectedBuilding.id])

  return (
    <div className={classes.paper}>
      <ListHeader bigTitle="Nuevo invitado" canCreate={false} />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese un nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
            capitalized: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Apellido',
            hint: 'Ingrese un apellido',
            key: 'surname',
            errorMessage: 'El apellido es requerido',
            capitalized: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Teléfono',
            hint: 'Ingrese un teléfono',
            key: 'phone',
            errorMessage: 'El teléfono es requerido',
          },
          {
            type: FieldTypes.TextField,
            label: 'Email',
            hint: 'Ingrese un email',
            key: 'email',
            errorMessage: 'El email es requerido',
          },
          ...(!building
            ? [
                {
                  type: FieldTypes.DoubleAutocomplete,
                  autocompletes: [
                    {
                      label: 'Cliente',
                      hint: 'Seleccione un cliente',
                      key: 'building',
                      options: buildingsState.buildings,
                      multiple: false,
                      freeSolo: false,
                      withMargin: true,
                      disabled: values.global,
                      onChange: (value) => {
                        setSelectedBuilding(value)
                      },
                    },
                    {
                      label: 'Unidad',
                      hint: 'Seleccione un apartamento',
                      key: 'apartment',
                      options: getApartmentsFromBuildingState.apartments,
                      multiple: false,
                      freeSolo: false,
                      withMargin: true,
                      disabled: values.global,
                      onChange: (value) => {
                        setApartment(value)
                      },
                    },
                  ],
                },
              ]
            : []),
          ...(building
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Unidad',
                  hint: 'Seleccione un apartamento',
                  key: 'apartment',
                  options: getApartmentsFromBuildingState.apartments,
                  multiple: false,
                  freeSolo: false,
                  withMargin: true,
                  onChange: (value) => {
                    setApartment(value)
                  },
                },
              ]
            : []),
        ]}
        handleSubmit={() => {
          onSubmit([
            {
              apartment: apartment.name.trim(),
              name: values.name.trim(),
              surname: values.surname.trim(),
              phone: values.phone.trim(),
              email: values.email.trim(),
              building: selectedBuilding.name.trim(),
            },
          ])
          history.push('/invitaciones')
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
